import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {AttachmentStatusesEnum} from '../../../../../models/api/attachmentModel';
import {AttachmentBasePublicProps} from './attachmentBase';
import {AttachmentBaseContainer} from './attachmentBaseContainer';

/*
 * Style.
 */

interface AttachmentStyleProps {
  $hasError: boolean;
  $hasLargeAttachmentView: boolean;
}

export const attachmentSpacing = 8;

const StyledAttachmentDiv = styled.div<AttachmentStyleProps>`
  display: inline-flex;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid ${(p) => p.theme.alphas.black40};
  ${(p) => addBackgroundStyle(p.$hasError, p.$hasLargeAttachmentView)};
`;

function addBackgroundStyle(hasError: boolean, hasLargeAttachmentView: boolean) {
  if (hasError) {
    return css`
      background-color: ${(p) => p.theme.palette.red.shade10};
      &:hover {
        background-color: ${(p) => p.theme.palette.red.shade20};
      }
    `;
  }

  return css`
    background-color: ${(p) => (hasLargeAttachmentView ? p.theme.greys.shade10 : p.theme.greys.white)};
    &:hover {
      background-color: ${(p) => p.theme.greys.shade20};
    }
  `;
}

/*
 * Component.
 */

export const MessageAttachment: FC<Omit<AttachmentBasePublicProps, 'hasError'>> = (props) => {
  const {attachment} = props;
  const hasError = attachment.status === AttachmentStatusesEnum.DRAFT && attachment.hasFailed;

  return (
    <StyledAttachmentDiv $hasError={hasError} $hasLargeAttachmentView={Boolean(props.hasLargeAttachmentView)}>
      <AttachmentBaseContainer {...props} hasError={hasError} />
    </StyledAttachmentDiv>
  );
};
